import { render, staticRenderFns } from "./TransferAdvertiserAmountModal.vue?vue&type=template&id=04750e05&"
import script from "./TransferAdvertiserAmountModal.vue?vue&type=script&lang=js&"
export * from "./TransferAdvertiserAmountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports